import {
  CommonUtils,
  StandardAction,
  StandardActionBuilder,
  SwitchActionBuilder,
} from '@infodata-group/inf-commons';

export const UNDO_ACTION = new StandardAction('undo', 'undo');
export const REDO_ACTION = new StandardAction('redo', 'redo');
export const DRAW_ACTION = new SwitchActionBuilder('draw', 'scribble')
  .setIsActive(true)
  .build();
export const HIGHLIGHT_ACTION = new SwitchActionBuilder(
  'highlight',
  'highlighter',
).build();
export const COLOR_ACTION = new StandardActionBuilder('color', 'circle fas')
  .setText('#000000')
  .build();
export const ERASER_ACTION = new SwitchActionBuilder(
  'eraser',
  'eraser',
).build();
export const DELETE_ACTION = new StandardActionBuilder('delete', 'trash-alt')
  .setText('Supprimer')
  .build();
export const IMPORT_BACKGROUND_ACTION = new StandardActionBuilder(
  'import-background',
  'image',
)
  .setText('Importer une image')
  .build();
export const ZOOM_IN_ACTION = new StandardAction('zoom-in', 'search-plus');
export const ZOOM_OUT_ACTION = new StandardAction('zoom-out', 'search-minus');
export const MOVE_ACTION = new StandardAction('move', 'arrows-alt');
export const FULLSCREEN_ACTION = new StandardActionBuilder(
  'fullscreen',
  'expand',
)
  .setText('Plein écran')
  .build();

const COLOR_BLACK = new StandardActionBuilder('color', 'circle fas')
  .setText('#000000')
  .build();
const COLOR_RED = new StandardActionBuilder('color', 'circle fas')
  .setText(CommonUtils.color('red'))
  .build();
const COLOR_ORANGE = new StandardActionBuilder('color', 'circle fas')
  .setText(CommonUtils.color('orange'))
  .build();
const COLOR_YELLOW = new StandardActionBuilder('color', 'circle fas')
  .setText(CommonUtils.color('yellow'))
  .build();
const COLOR_GREEN = new StandardActionBuilder('color', 'circle fas')
  .setText(CommonUtils.color('green'))
  .build();
const COLOR_BLUE = new StandardActionBuilder('color', 'circle fas')
  .setText('#4fc1e9')
  .build();
const COLOR_PURPLE = new StandardActionBuilder('color', 'circle fas')
  .setText(CommonUtils.color('purple'))
  .build();
const COLOR_PINK = new StandardActionBuilder('color', 'circle fas')
  .setText(CommonUtils.color('pink'))
  .build();
const COLOR_WHITE = new StandardActionBuilder('color', 'circle fas')
  .setText(CommonUtils.color('white'))
  .build();

export const COLORS = [
  COLOR_BLACK,
  COLOR_RED,
  COLOR_ORANGE,
  COLOR_YELLOW,
  COLOR_GREEN,
  COLOR_BLUE,
  COLOR_PURPLE,
  COLOR_PINK,
  COLOR_WHITE,
];
